const initialStateStudentProfile = {
  loading: false,
  error: null,
  student: {
    id: 1,
    name: null,
    email: null,
    classes: [],
    licenses: [
      {
        courses: [],
        programLicenses: []
      }
    ]
  },
  statusCode: null
};

export function studentProfileReducer(
  state = initialStateStudentProfile,
  action
) {
  switch (action.type) {
    case "FETCH_STUDENT_PROFILE_BEGIN": {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case "FETCH_STUDENT_PROFILE_SUCCESS": {
      return {
        ...state,
        loading: false,
        student: action.payload
      };
    }
    case "FETCH_STUDENT_PROFILE_FAILURE": {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        student: null
      };
    }
    default:
      return state;
  }
}
